/***
 *
 *   RADIO STYLES
 *   Native radio tinted with accent-color, matching the checkbox treatment.
 *
 **********/

const Style = {
    radio: 'flex items-start',
    input: `mr-2 mt-0.5 h-4 w-4 shrink-0 cursor-pointer border-border accent-primary-600
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
    label: 'mt-px cursor-pointer text-sm font-normal normal-case text-text-primary',
};

export default Style;
